import { render, staticRenderFns } from "./AppWorkAnalyzerFilterBar.vue?vue&type=template&id=525e36a9&scoped=true&"
import script from "./AppWorkAnalyzerFilterBar.vue?vue&type=script&lang=js&"
export * from "./AppWorkAnalyzerFilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e36a9",
  null
  
)

export default component.exports